import React, {lazy, Suspense} from 'react'

const DepartmentPageLazy = lazy(() =>
    import('./DepartmentPage')
)

const DepartmentPage = props => (
    <Suspense fallback={null}>
        <DepartmentPageLazy {...props} />
    </Suspense>
)

export default DepartmentPage
